const config = {
  node_env: process.env.NODE_ENV,
  base_url: process.env.REACT_APP_API_BASE_URL,
};

export default config;
